import fetch from 'cross-fetch'
import { common } from '../../main/common-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'

const namespace = 'voyage-json-server'
// const filename = 'voyage'
const _dir = 'voyage-ships'

export function save(filename: string, data: any, dir = _dir) {
  console.log(namespace, 'attempt to save', filename)
  fetch('//localhost:4500/put', {
    method: 'POST',
    body: JSON.stringify(
      {
        filename,
        dir,
        data, //: JSON.stringify(data, null, 2),
      },
      null,
      2,
    ),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {})
    .catch((err) => {
      console.error(namespace, err)
    })
}

// export function load() {
//   console.log(namespace, 'attempt to load', filename)

//   if (voyageTestParams.isDevMode) {
//     fetch('//localhost:4500/get', {
//       method: 'POST',
//       body: JSON.stringify(
//         {
//           filename,
//           dir,
//         },
//         null,
//         2,
//       ),
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//       .then((res) => {
//         console.log('loaded')
//         res.json().then((res2) => {
//           //console.log(res2)
//         })
//       })
//       .catch((err) => {
//         console.error(namespace, err)
//       })
//   } else {
//   }
// }

export async function loadAsync(filename: string, dir = _dir) {
  console.log(namespace, 'attempt to load', filename)

  try {
    if (voyageTestParams.isDevMode) {
      const res = await fetch('//localhost:4500/get', {
        method: 'POST',
        body: JSON.stringify(
          {
            filename,
            dir,
          },
          null,
          2,
        ),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const json = await res.json()
      console.log(namespace, 'loaded')
      return json
    } else {
      console.log('get raw json...')
      const res = await fetch('assets/data/' + dir + '/' + filename + '.json', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const json = await res.json()
      return json
      // TODO: fix this!
      // return common.getPhaserScene().cache.json.get(filename)
    }
  } catch (err) {
    console.error(namespace, err)
  }
}

export function list(on: (list: string[]) => void) {
  console.log(namespace, 'listing')
  // _list = ['Loading...']
  fetch('//localhost:4500/list', {
    method: 'POST',
    body: JSON.stringify({
      dir: _dir,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      console.log('loaded')
      res.json().then((res2) => {
        console.log(res2)
        on(res2)
      })
    })
    .catch((err) => {
      console.error(namespace, err)
    })
}
